import styled from '@emotion/styled'

type FormSectionProps = {
	title: string
	children: React.ReactNode
}

const FormSection = ({ title, children }: FormSectionProps) => {
	return (
		<Section>
			<SectionTitle>{title}</SectionTitle>
			<Field>{children}</Field>
		</Section>
	)
}

const Section = styled.section`
	display: flex;

	& + & {
		margin-top: 10rem;
	}
`

const SectionTitle = styled.h4`
	font-size: 2rem;
	font-weight: 700;
	width: 15rem;
`

const Field = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`

export default FormSection
